import { render, staticRenderFns } from "./SaveForm.vue?vue&type=template&id=ffef9e48&scoped=true&"
import script from "./SaveForm.vue?vue&type=script&lang=js&"
export * from "./SaveForm.vue?vue&type=script&lang=js&"
import style0 from "./SaveForm.vue?vue&type=style&index=0&id=ffef9e48&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef9e48",
  null
  
)

export default component.exports